import { useDispatch, useSelector } from 'react-redux';
import { selectEPLICoverageLimit, selectEPLIRetentionLimit } from '../../../../selectors/application';
import { setEPLICoverage, setCheckedEndorsement } from '../../../../actions/application';
import { formatCurrency } from '../../../../helpers/formatNumber';
import { EndorsementKey } from '../../types';
import EndorsementSummaryCardLayout from '../../../Summary/Endorsements/EndorsementSummaryCardLayout';

const limitsMap: Record<string, { perClaimLimit: string; aggregateLimit: string }> = {
  '50000/50000': { perClaimLimit: '$50,000', aggregateLimit: '$50,000' },
  '100000/100000': { perClaimLimit: '$100,000', aggregateLimit: '$100,000' },
  '250000/250000': { perClaimLimit: '$250,000', aggregateLimit: '$250,000' },
};

const EPLISummaryCard = ({ value }: { value: any }) => {
  const dispatch = useDispatch();
  const epliCoverageLimit = useSelector(selectEPLICoverageLimit);
  const epliRetentionLimit = useSelector(selectEPLIRetentionLimit);

  const { perClaimLimit, aggregateLimit } = limitsMap[epliCoverageLimit] || {
    perClaimLimit: '--',
    aggregateLimit: '--',
  };
  const retention = epliRetentionLimit ? formatCurrency(Number(epliRetentionLimit)) : '--';

  const coverageInfo = [
    { coverage: 'Per Claim', limit: perClaimLimit },
    { coverage: 'Aggregate', limit: aggregateLimit },
    { coverage: 'Retention', limit: retention },
  ];

  const handleRemove = () => {
    dispatch(setCheckedEndorsement(EndorsementKey.EpliCoverage, false));
    dispatch(setEPLICoverage(null));
  };

  const handleRestore = () => {
    dispatch(setCheckedEndorsement(EndorsementKey.EpliCoverage, true));
    dispatch(setEPLICoverage(value));
  };

  return (
    <EndorsementSummaryCardLayout
      label="Employment Practices Liability Insurance (EPLI)"
      coverageInfo={coverageInfo}
      onRemove={handleRemove}
      onRestore={handleRestore}
    />
  );
};

export default EPLISummaryCard;
